import React from "react";
import Link from "theme/components/atoms/Typography/Link";
import Image from "theme/components/atoms/Image";
import { ProductPrice } from "theme/components/atoms/Typography/Price";
import AutocompleteItem from "theme/components/organisms/Autocomplete/AutocompleteItem/AutocompleteItem";

const ProductItem = ({ selected, result }) => {
  return (
    <AutocompleteItem
      image={
        <Image
          src={result.imageUrl}
          alt={result.name}
          format="thumbnail"
          appearance="full"
        />
      }
      name={
        <Link key={result.sku} to={result.path} clickType="block">
          {result.name}
        </Link>
      }
      addon={<ProductPrice prices={result.prices} />}
    />
  );
};

export default ProductItem;
